console.log("GSAP TEXT IMAGE TECHNOLOGY LOADED");

document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll("[data-gsap-ti-tech]").forEach((section) => {
    const overlay = section.querySelector(".ti-tech__image--overlay");
    const content = section.querySelector(".ti-tech__content");

    if (!overlay || !content) return;

    /* =========================
       ÉTAT INITIAL (CLEAN)
    ========================= */

    gsap.set(section, { "--mask-progress": "100%" });
    overlay.classList.remove("is-masked");

    /* =========================
       TIMELINE IMAGE / TEXTE
    ========================= */

    gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top center",
        end: "bottom-=25% center",
        scrub: true
      }
    })
    .to(overlay, {
      xPercent: -100,
      ease: "none"
    }, 0)
    .to(content, {
      opacity: 1,
      y: 0,
      ease: "power2.out"
    }, 0.25);

    /* =========================
       MASK — TRIGGER DÉDIÉ
    ========================= */

    ScrollTrigger.create({
      trigger: section,
      start: "top+=10% bottom",
      end: "top+=10% top+=10%",
      scrub: true,

      onEnter: () => {
        overlay.classList.add("is-masked");
        gsap.set(section, { "--mask-progress": "100%" });
      },

      onEnterBack: () => {
        overlay.classList.add("is-masked");
        gsap.set(section, { "--mask-progress": "0%" });
      },

      onUpdate: (self) => {
        gsap.set(section, {
          "--mask-progress": `${100 - self.progress * 100}%`
        });
      },

      onLeave: () => {
        // 🔥 reverse fluide
        gsap.to(section, {
          "--mask-progress": "100%",
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            overlay.classList.remove("is-masked");
          }
        });
      },

      onLeaveBack: () => {
        // 🔥 reverse fluide
        gsap.to(section, {
          "--mask-progress": "100%",
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            overlay.classList.remove("is-masked");
          }
        });
      }
    });
  });
});


















// console.log("GSAP TEXT IMAGE TECHNOLOGY LOADED");

// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   document.querySelectorAll("[data-gsap-ti-tech]").forEach((section) => {
//     const overlayImage = section.querySelector(".ti-tech__image--overlay");
//     const content = section.querySelector(".ti-tech__content");

//     if (!overlayImage || !content) return;

//     /* =========================
//        ÉTAT INITIAL
//     ========================= */

// gsap.set(section, {
//   "--mask-progress": "0%"
// });
// overlayImage.classList.remove("is-masked");
//     /* =========================
//        TIMELINE PRINCIPALE
//     ========================= */

//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: section,
//         start: "top center",
//         end: "bottom-=25% center",
//         scrub: true
//         // markers: true
//       }
//     });

//     tl.to(overlayImage, {
//       xPercent: -100,
//       ease: "none"
//     }, 0);

//     tl.to(content, {
//       opacity: 1,
//       y: 0,
//       ease: "power2.out"
//     }, 0.25);

//     /* =========================
//        MASK — TRIGGER DÉDIÉ
//     ========================= */

// ScrollTrigger.create({
//   trigger: section,
//   start: "top+=10% bottom",
//   end: "top+=10% top+=10%",
//   scrub: true,
//   markers: true,

//   onEnter: () => {
//     overlayImage.classList.add("is-masked");
//   },

//   onUpdate: (self) => {
//     gsap.set(section, {
//       "--mask-progress": `${self.progress * 100}%`
//     });
//   },

// onLeave: () => {
//   overlayImage.classList.remove("is-masked");

//   // 🔥 RESET HARD GPU
//   gsap.set(overlayImage, {
//     webkitMaskImage: "none",
//     maskImage: "none",
//     webkitMaskPosition: "0% 0%",
//     maskPosition: "0% 0%"
//   });

//   gsap.set(section, { "--mask-progress": "0%" });
// },

//   onLeaveBack: () => {
//     overlayImage.classList.remove("is-masked");
//     gsap.set(section, { "--mask-progress": "0%" });
//   }
// });

//   });
// });